import Vue from "vue";
import Owner from "@/model/cospirit-api/Owner";
import TypeRepository from "@/repositories/request/TypeRepository";

export interface Type {
    uuid: string;
    label: string;
    code?: string|null;
    owner: Owner;
}

export default {
    state: {
        types: [],
    },
    mutations: {
        setTypes: (state: any, types: Type[]) => {
            Vue.set(state, "types", types);
        },
    },
    getters: {
        getTypes: (state: any) => {
            return state.types;
        },
    },
    actions: {
        loadTypes: ({ commit }: any) => {
            commit("setTypes", []);
            TypeRepository.get().then((data: any) => {
                commit("setTypes", data);
            });
        },
    },
};
